<script lang="ts">
import { defineComponent } from 'vue';
import { ArrowLeftIcon } from 'vue-feather-icons';

export default defineComponent({
  name: 'ChatHeader',
  components: {
    ArrowLeftIcon ,
  },
  props: {
    avatarUrl: { type: String, required: true },
    title: { type: String, default: '' },
    fullHeader: { type: Boolean, default: false },
    newChat: { type: Boolean, default: false },
  },
  emits: ['close', 'back'],
});
</script>

<template>
  <div>
    <div v-if="fullHeader" class="relative flex items-center justify-between px-4 pr-10 border-b border-gray-200 bg-gradient-to-r from-[#8A53F1CC] to-[#50308B] rounded-t-lg">
      <div class="flex items-center gap-2 flex-1 min-w-0 pr-24">
        <span v-if="title" class="font-bold text-gray-900 text-base text-ellipsis overflow-hidden whitespace-nowrap">{{ title }}</span>
        <div v-else class="flex flex-col items-start">
          <span class="font-bold text-white text-base/[20px] whitespace-nowrap">Precisa de ajuda?</span>
          <span class="font-bold text-white text-base/[20px] whitespace-nowrap">Fale com a Rose</span>
        </div>
      </div>
      <div class="flex items-center justify-end gap-1">
        <img :src="avatarUrl" alt="Rose" class="h-full object-contain mr-8" />
      </div>
      <div class="absolute top-0 right-0 mt-1 mr-1 z-10 pointer-events-auto">
        <slot name="actions">
          <button
            @click="$emit('close')"
            class="text-gray-200 hover:text-white transition-colors p-1 rounded-full focus:outline-none"
            aria-label="Fechar chat"
          >
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-width="2" d="M6 6l12 12M6 18L18 6" />
            </svg>
          </button>
        </slot>
      </div>
    </div>

    <div v-else class="flex items-center justify-between px-2 border-b border-gray-200 bg-[#8A53F1F2] rounded-t-lg">
      <div class="flex items-center gap-2 py-1 flex-1 min-w-0">
        <button
          @click="$emit('back')"
          class="text-white hover:text-gray-100 transition-colors rounded-full focus:outline-none"
          aria-label="Voltar"
        >
          <ArrowLeftIcon icon="arrow-left" class="w-4 h-4" />
        </button>
        <div v-if="!newChat" class="flex-shrink-0 bg-white rounded-full flex items-center justify-center" style="max-width: 20px;">
          <img :src="avatarUrl" alt="Rose" class="w-5 h-5 object-contain" />
        </div>
        <span class="font-medium text-white text-xs/[20px] truncate">{{ title || 'Nova conversa' }}</span>
      </div>
      <div class="flex items-center gap-1 py-1 justify-end flex-none ml-2">
        <slot name="actions">
          <button
            @click="$emit('close')"
            class="text-gray-200 hover:text-white transition-colors p-1 rounded-full focus:outline-none"
            aria-label="Fechar chat"
          >
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24">
              <path stroke="#E2E6E9" stroke-width="2" d="M6 6l12 12M6 18L18 6" />
            </svg>
          </button>
        </slot>
      </div>
    </div>
  </div>
</template> 